import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const list = (systemSource, merchantId, payload) => {
	return Client.get(
		systemSourceUrl(systemSource, `/priceTable/list/${merchantId}`),
		payload
	);
};

const create = (systemSource, merchantId, payload) => {
	return Client.post(
		systemSourceUrl(systemSource, `/${merchantId}/categorys`),
		payload
	);
};

const find = (systemSource, id, payload) => {
	return Client.get(
		systemSourceUrl(systemSource, `/priceTable/detail/${id}`),
		payload
	);
};

const update = (systemSource, payload) => {
	return Client.post(
		systemSourceUrl(systemSource, '/priceTable/save'),
		payload
	);
};

const releaseConfig = (systemSource, priceTableConfigVersionId, payload) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`/priceTable/release/${priceTableConfigVersionId}`
		),
		payload
	);
};

const remove = (systemSource, id, payload) => {
	return Client.post(
		systemSourceUrl(systemSource, `/priceTable/delete/${id}`),
		payload
	);
};

const discard = (systemSource, priceTableConfigVersionId, payload) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`/priceTable/discard/${priceTableConfigVersionId}`
		),
		payload
	);
};

const historyList = (systemSource, merchantId, id, payload) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/priceTable/listVersion/${merchantId}/${id}`
		),
		payload
	);
};

const branchCategoryList = (systemSource, payload) => {
	return Client.get(
		systemSourceUrl(systemSource, '/productCategory/branches-list'),
		payload
	);
};

const branchProductList = (systemSource, payload) => {
	return Client.get(
		systemSourceUrl(systemSource, '/product/branches-list'),
		payload
	);
};

const categoryProductList = (systemSource, payload) => {
	return Client.get(
		systemSourceUrl(systemSource, '/product/productsByCategoryCodes'),
		payload
	);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	discard,
	releaseConfig,
	historyList,
	branchCategoryList,
	branchProductList,
	categoryProductList,
};
